module.exports = __webpack_public_path__ + "img/product1.518fb9bb.png";